(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:SendSmsCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('SendSmsCtrl', SendSmsCtrl);

    function SendSmsCtrl($uibModalInstance, CrewingHelper, modalParams,MessageService, CommonMasterData) {
        var vm = this;
        vm.model = {
          allSelect : true,
          crewDetails : modalParams.joiningCrew,
          crewTypes : [],
          signOut:[],
            request : {
                crewProfileId : modalParams.isForDay ? [modalParams.crew.crewDTO.crewProfileId] : [],
                message: modalParams.messageContent,
                no_of_house: 24,
                isConfirm : false
            },
            crewName: modalParams.isForDay ? modalParams.crew.crewDTO.firstName + ' ' + modalParams.crew.crewDTO.lastName : "",

        };

      vm.predicate = function (roleOrder) {
        return function (item) {
          return !roleOrder || item.crewTypeCode === roleOrder.crewTypeCode;
        };
      };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        vm.onSendSms = function () {
          for (var i in vm.model.crewDetails){
            if(vm.model.crewDetails[i].isChecked){
              vm.model.request.crewProfileId.push(vm.model.crewDetails[i].crewProfileId);
            }
          }
            if(!!vm.model.request.message){
                CrewingHelper.sendSMS(vm.model.request,
                    function(data){
                        if(data.success) {
                            $uibModalInstance.close('SUCCESS');
                            MessageService.success("SMS Sent Successfully");
                        } else {
                            MessageService.error("SMS message failed to send");
                        }
                    },
                    function(error){
                        $uibModalInstance.close();
                        MessageService.error(error.msg[0]);
                    }
                );
            }else{
                MessageService.warning(MessageService.MESSAGES.CREWING.MESSAGE_EMPTY_CONTENT);
            }

        }

      vm.clickOnRow = function() {
          if (!vm.model.allSelect){
            for (var i in vm.model.crewDetails){
              vm.model.crewDetails[i].isChecked = vm.model.allSelect;
            }
            vm.model.allSelect = true;
            return vm.model.crewDetails;
          }else {
            for (var i in vm.model.crewDetails){
              vm.model.crewDetails[i].isChecked = vm.model.allSelect;
            }
            vm.model.allSelect = false;
          }

      };

      CommonMasterData.getCrewTypeList(function(crewTypes) {
        vm.model.crewTypes = crewTypes;
      }, function() {
        console.log('Crew type retrieval error');
      });
    }

}());
